<template>
  <Teleport to="body">
    <div v-show="visible" class="archive-modal-overlay" @click="onCancel">
      <div class="archive-modal-box" @click.stop>

        <div v-if="isLoading" class="archive-modal-state">
          <div class="archive-modal-spinner"></div>
          <p class="archive-modal-title">{{ isUnarchive ? 'Unarchiving...' : 'Archiving...' }}</p>
          <p class="archive-modal-sub">Please wait</p>
        </div>

        <div v-else-if="isSuccess" class="archive-modal-state">
          <div class="archive-modal-success">✓</div>
          <p class="archive-modal-title">{{ isUnarchive ? 'Survey Unarchived!' : 'Survey Archived!' }}</p>
          <p class="archive-modal-sub">{{ isUnarchive ? 'Moved back to your active surveys.' : 'Hidden from your main view.' }}</p>
          <button class="archive-modal-done" @click="onDone">Done</button>
        </div>

        <div v-else class="archive-modal-state">
          <div class="archive-modal-icon">🗄️</div>
          <p class="archive-modal-title">{{ isUnarchive ? 'Unarchive Survey?' : 'Archive Survey?' }}</p>
          <p class="archive-modal-sub">
            {{ isUnarchive 
              ? 'This survey will be moved back to your active surveys list.' 
              : 'This survey will be hidden from your main view. You can access it anytime by clicking "Show Archived" at the top.' 
            }}
          </p>
          <div class="archive-modal-actions">
            <button class="archive-modal-cancel" @click="onCancel">Cancel</button>
            <button class="archive-modal-confirm" @click="onConfirm">
              {{ isUnarchive ? 'Unarchive' : 'Archive' }}
            </button>
          </div>
        </div>

      </div>
    </div>
  </Teleport>
</template>

<script>
export default {
  name: 'ArchiveConfirmModal',
  props: {
    visible: Boolean,
    isLoading: Boolean,
    isSuccess: Boolean,
    isUnarchive: Boolean,
  },
  emits: ['confirm', 'cancel', 'done'],
  methods: {
    onConfirm() { 
      console.log('[ArchiveConfirmModal] onConfirm clicked - visible:', this.visible, 'isLoading:', this.isLoading);
      this.$emit('confirm'); 
    },
    onCancel() { if (!this.isLoading) this.$emit('cancel'); },
    onDone() { this.$emit('done'); },
  }
}
</script>

<style>
.archive-modal-overlay {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
}
.archive-modal-box {
  background: white;
  border-radius: 12px;
  max-width: 440px;
  width: 90%;
  box-shadow: 0 8px 32px rgba(0,0,0,0.3);
}
.archive-modal-state {
  padding: 40px 24px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
.archive-modal-spinner {
  width: 52px; height: 52px;
  border: 4px solid #f0f0f0;
  border-top: 4px solid #6c757d;
  border-radius: 50%;
  animation: archiveSpin 0.9s linear infinite;
}
@keyframes archiveSpin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.archive-modal-success {
  font-size: 52px;
  color: #28a745;
}
.archive-modal-icon {
  font-size: 48px;
}
.archive-modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
}
.archive-modal-sub {
  font-size: 14px;
  color: #666;
  margin: 0;
}
.archive-modal-actions {
  display: flex;
  gap: 12px;
  width: 100%;
  margin-top: 8px;
}
.archive-modal-cancel {
  flex: 1;
  padding: 10px;
  border-radius: 8px;
  border: none;
  background: #f0f0f0;
  color: #333;
  font-weight: 600;
  cursor: pointer;
}
.archive-modal-confirm {
  flex: 1;
  padding: 10px;
  border-radius: 8px;
  border: none;
  background: #6c757d;
  color: white;
  font-weight: 600;
  cursor: pointer;
}
.archive-modal-done {
  padding: 10px 32px;
  border-radius: 8px;
  border: none;
  background: #28a745;
  color: white;
  font-weight: 600;
  cursor: pointer;
  margin-top: 4px;
}
</style>